import { render, staticRenderFns } from "./FixturesList.vue?vue&type=template&id=76f18ab0&scoped=true"
import script from "./FixturesList.vue?vue&type=script&lang=js"
export * from "./FixturesList.vue?vue&type=script&lang=js"
import style0 from "./FixturesList.vue?vue&type=style&index=0&id=76f18ab0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76f18ab0",
  null
  
)

export default component.exports